import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "app/services/auth/auth.service";
import { LocalStorageService } from "app/services/local-storage/local-storage.service";

@Injectable()
export class AuthGuard {
    constructor(
        private auth: AuthService,
        private router: Router,
        private storage: LocalStorageService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.auth.isAuthenticated()) {
            this.storage.clear();
            this.router.navigate(["login"]);
            return false;
        }
        return true;
    }
}
